import type { Query, QueryPositionPriceObjectsArgs } from '@ab-core/graphql/dist';

type PositionsType = NonNullable<QueryPositionPriceObjectsArgs['positions']>;
type PositionPriceObjectsType = NonNullable<Query['positionPriceObjects']>;

export const MAX_POSITION_PRICE_OBJECTS_PER_REQUEST = 50;

export const splitPositionPriceObjectRequests = (positions: PositionsType): Array<PositionsType> => {
    const batches: Array<PositionsType> = [];

    for (let index = 0; index < positions.length; index += MAX_POSITION_PRICE_OBJECTS_PER_REQUEST) {
        batches.push(positions.slice(index, index + MAX_POSITION_PRICE_OBJECTS_PER_REQUEST));
    }

    return batches;
};

export const fetchPositionPriceObjectsInBatches = async (
    positions: PositionsType,
    fetchBatch: (batch: PositionsType) => Promise<Query['positionPriceObjects']>
): Promise<PositionPriceObjectsType> => {
    const results = await Promise.all(splitPositionPriceObjectRequests(positions).map(fetchBatch));

    return results.flatMap((result) => result || []);
};
